import { Button } from '@shopify/polaris'

function PlanFooterMainButton({ shop, changePlan, pricingPlan }) {
  const hasThatPlan = shop.pricingPlan === pricingPlan.name

  return (
    <span>
      <Button
        disabled={shop.billingNeedsReview || (hasThatPlan && !shop.accessPlanOverride)}
        primary={!hasThatPlan}
        onClick={() => changePlan(pricingPlan.name)}
      >
        {hasThatPlan && shop.accessPlanOverride ? 'Use billed plan access' : pricingPlan.buttons.Main(shop)}
      </Button>
    </span>
  )
}

export default PlanFooterMainButton
